/* ────────────────────────────────────────────────────────────────────
 * Homepage "What Prinotes does" section (Arabic / العربية) — MSA.
 *
 * Arabic mirror of home-features-en.ts. Same house rules as the legal/about
 * Arabic files: MSA, verb-first, no harakat unless disambiguating, no em/en
 * dashes, برَينوتس / برييورا transliterated, Latin brand names (Google) left
 * Latin. Terminology matches legal-ar.ts: التقويم، جهات الاتصال، المهام،
 * "تُقرأ لحظيا".
 * ──────────────────────────────────────────────────────────────────── */

import type { HomeFeaturesDoc } from './home-features-en';

export const HOME_FEATURES_AR: HomeFeaturesDoc = {
  eyebrow: 'آلية العمل',
  heading: 'كيف يساعدك برَينوتس؟',
  lead: 'يسجل برَينوتس اجتماعاتك ويفرّغها إلى نصوص، ويحوّلها إلى ملاحظات منظمة ومهام ومتابعات. وعند ربط حسابك في Google أو Microsoft، لا يصل إلا إلى ما تتطلبه كل ميزة، وتبقى المزامنة تحت تحكمك.',
  features: [
    {
      title: 'يسجل المحادثات والاجتماعات يدويًا أو تلقائيًا، ويفرّغها إلى نصوص ومحاضر منظمة',
      body: 'حوّل محادثاتك واجتماعاتك إلى ملاحظات وملخصات ومهام واضحة خلال ثوانٍ. سواء سجّلت الاجتماع مباشرة أو رفعت تسجيله، اترك لبرَينوتس الباقي. التسجيل التلقائي يصل مع تطبيق برَينوتس (قريبًا).',
    },
    {
      title: 'يعينك على دعوة المشاركين من جهات اتصالك',
      body: 'اعثر على المشاركين بسرعة وأنت تدعو الحضور أو تُسند المهام. يقرأ برَينوتس جهات اتصالك في Google ليقترح الأسماء أثناء الكتابة، دون تعديلها أو تخزينها أو مشاركتها.',
    },
    {
      title: 'يعرض تقويم اجتماعاتك داخل برَينوتس',
      body: 'أدِر اجتماعاتك من مكان واحد. يعرض برَينوتس أحداث تقويم Google أو Outlook في تقويم واحد، ويحوّل الأحداث القادمة إلى اجتماعات مجدولة، مع إمكانية إنشاء الأحداث وتعديلها وحذفها والرد على الدعوات، وإضافة متابعات الاجتماعات عند الحاجة.',
    },
    {
      title: 'يرسل المهام إلى مهام Google أو Microsoft To Do',
      body: 'بنقرة واحدة، يضيف برَينوتس المهام التي ينشئها إلى قائمة مهامك في مهام Google أو Microsoft To Do. وتقتصر المزامنة على المهام التي ينشئها برَينوتس، دون الوصول إلى مهامك الأخرى.',
    },
    {
      title: 'يحفظ ملفات اجتماعاتك في حسابك على Google Drive أو OneDrive',
      body: 'يحفظ برَينوتس تسجيل كل اجتماع ونصه المفرغ مباشرة في حسابك على Google Drive أو OneDrive، لتبقى لديك نسخة في حساب تملكه أنت. مفعّل افتراضيًا، وتوقفه متى شئت، ولا يمس إلا الملفات التي ينشئها لك.',
    },
  ],
  privacyBefore: 'تبقى بياناتك تحت تحكمك. تعرّف في ',
  privacyLinkLabel: 'سياسة الخصوصية',
  privacyAfter: ' على تفاصيل كل ربط وكيف نحميها.',
  limitedUse:
    'لا يبيع برَينوتس بيانات Google أو Microsoft، ولا يستخدمها للإعلانات أو لتدريب نماذج الذكاء الاصطناعي. ويتقيد استخدام برَينوتس لبيانات Google بسياسة بيانات مستخدمي خدمات Google API، بما فيها متطلبات الاستخدام المحدود.',
};
